// ===========================================
// DEMO 3 PAGE - SPLITS TESTING TABLE
// ===========================================
// Auto-redirects to the splits testing table (all 4s)
// ===========================================

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function Demo3Page() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the demo3 table
    navigate('/table/demo3', { replace: true });
  }, [navigate]);

  // Show loading state while redirecting
  return (
    <div className="flex items-center justify-center h-screen bg-green-900">
      <div className="text-white text-xl flex items-center gap-3">
        <div className="animate-spin w-6 h-6 border-2 border-white border-t-transparent rounded-full" />
        <span>Joining Splits Testing Table...</span>
      </div>
    </div>
  );
}

export default Demo3Page;
